import React, { Component } from "react";
import { Row, Col, Card, Form } from "reactstrap";
import CgnTextbox from "../toolbox/CgnTextbox";
import CgnAlert from "../toolbox/CgnAlert";
import CgnButtonGroup from "../toolbox/CgnButtonGroup";
import CgnLoader from "../toolbox/CgnLoader";
import CgnMessage from "../toolbox/CgnMessage";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {
  URL,
  
} from "../../redux/actions/constants";
import { withRouter } from "react-router-dom";

class ManuelControlTemplateAddUpdate extends Component {
  state = {
    pageTitle: "Manuel Kontrol Şablon Ekle",
    pageTitleAdd: "Manuel Kontrol Şablon Ekle",
    pageTitleUpdate: "Manuel Kontrol Şablon Güncelle",
    pageAddLink: "manuel-kontrol-sablon-ekle",
    pageListLink: "manuel-kontrol-sablon-listele",
    breadcrumb: [{ text: "Manuel Kontrol Şablon", link: "#" }],
    isLoading: false,
    urlSplit: [],
    name: "",
    outConnector: "",
    pinNo: "",
    arrivalConnector: "",
    pinNo2: "",
    guid: "",
    color: "",
    status: true,
    nameError: "",
    outConnectorError: "",
    pinNo2Error: "",
    pinNoError: "",
    arrivalConnectorError: "",
    alertErrorMessage: "",
    buttons: [
      {
        type: "button",
        color: "secondary",
        text: CgnMessage.clearButton,
        onClick: (event) => this.handleClear(event),
        disabled: this.isLoading,
      },
      {
        type: "submit",
        color: "primary",
        text: CgnMessage.saveButton,
        disabled: this.isLoading,
      },
    ],
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });
    let urlSplit = window.location.pathname.split("/");
    this.setState({
      urlSplit: urlSplit,
    });
    if (urlSplit.length === 3) {
      this.setState({
        guid: urlSplit[urlSplit.length - 1],
        pageTitle: this.state.pageTitleUpdate,
        isLoading: true,
      });
      this.getById(urlSplit[2]);
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/manuelControlTemplates/get/" + urlSplit[2], config)
        .then((response) => {
          if (this.state.guid) {
            this.setState({
              outConnector: response.data.outConnector,
              pinNo: response.data.pinNo,
              arrivalConnector: response.data.arrivalConnector,
              pinNo2: response.data.pinNo2,
              status: response.data.status,
              isLoading: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        isLoading: false,
      });
    }
  }

  componentDidUpdate() {
    let urlSplit = window.location.pathname.split("/");
    if (
      urlSplit.length === 2 &&
      this.state.pageTitle !== this.state.pageTitleAdd
    ) {
      this.setState({
        urlSplit: urlSplit,
        pageTitle: this.state.pageTitleAdd,
        name: "",
        status: true,
      });
    }
    if (this.state.status === undefined) {
      this.setState({
        status: true,
      });
    }
  }

  getById(guid) {
    this.setState({
      isLoading: true,
      guid: guid,
    });
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
    this.setState({
      outConnectorError: "",
      pinNoError:"",
      arrivalConnectorError: "",
      pinNo2Error: "",
      alertErrorMessage: "",
    });
    if (name === "outConnector" && value === "") {
      this.setState({
        outConnectorError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "arrivalConnector" && value === "") {
      this.setState({
        arrivalConnectorError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "pinNo" && value === "") {
      this.setState({
        pinNoError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "pinNo2" && value === "") {
      this.setState({
        pinNo2Error: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };

  handleClear = (event) => {
    this.clearPage();
  };

  clearPage() {
    this.setState({
      outConnector: "",
      pinNo: "",
      pinNo2: "",
      arrivalConnector: "",
      status: true,
      alertErrorMessage: CgnMessage.alertErrorMessage,
      outConnectorError: CgnMessage.textErrorMessage,
      arrivalConnectorError: CgnMessage.textErrorMessage,
      pinNoError: CgnMessage.textErrorMessage,
      pinNo2Error: CgnMessage.textErrorMessage,
    });
  }

  handleStatusSelectChange(status) {
    this.setState({ status: status.value });
  }
  
  handleChangeComplete = (color) => {
    this.setState({ color: color.hex });
  };

  handleSave = async (event) => {
    event.preventDefault();
    this.setState({
      alertErrorMessage: "",
      nameError: "",
    });
    if (this.state.outConnector === "") {
      this.setState({
        outConnectorError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.arrivalConnector === "") {
      this.setState({
        arrivalConnectorError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.pinNo === "") {
      this.setState({
        pinNoError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.pinNo2 === "") {
      this.setState({
        pinNo2Error: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
     if (this.state.pinNo !== "" &&
     this.state.pinNo2 !== "" &&
     this.state.outConnector !== "" &&
     this.state.arrivalConnector !== "") {
      this.setState({
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var myObj = {
        outConnector: this.state.outConnector,
        pinNo: this.state.pinNo,
        arrivalConnector: this.state.arrivalConnector,
        pinNo2: this.state.pinNo2,
        status: this.state.status,
      };
      var URLParam = "/manuelControlTemplates/add";
      if (
        this.state.guid &&
        this.state.urlSplit.length !== 2 &&
        this.state.urlSplit[1] === "manuel-kontrol-sablon-guncelle"
      ) {
        URLParam = "/manuelControlTemplates/update";
        myObj = {
          guid: this.state.guid,
          outConnector: this.state.outConnector,
          pinNo: this.state.pinNo,
          arrivalConnector: this.state.arrivalConnector,
          pinNo2: this.state.pinNo2,
          status: this.state.status,
        };
      }
      axios
        .post(URL + URLParam, myObj, config)
        .then(() => {
          setTimeout(() => {
            if (
              this.state.guid &&
              this.state.urlSplit[1] === "manuel-kontrol-sablon-guncelle"
            ) {
              window.location.href = "/manuel-kontrol-sablon-listele";
            }
            if (this.state.urlSplit[1] === "manuel-kontrol-sablon-ekle") {
              window.location.reload();
            }
            var modalAddedManuelControlTemplate = {
              data: this.state.outConnector,
              isModal: false,
            };
            this.props.history.push({ modalAddedManuelControlTemplate });
            this.setState({
              isLoading: false,
            });
          }, 1500);
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };

  render() {
    return (
      <>
        {(this.state.urlSplit[1] === "manuel-kontrol-sablon-ekle" ||
          this.state.urlSplit[1] === "manuel-kontrol-sablon-guncelle") && (
          <ContentTop
            breadcrumb={this.state.breadcrumb}
            title={this.state.pageTitle}
            addLink={"/" + this.state.pageAddLink}
            listLink={"/" + this.state.pageListLink}
          />
        )}
        <Row>
          <Col>
            <Form onSubmit={this.handleSave}>
              <Card body>
                <CgnLoader visibled={this.state.isLoading} />

                <Row>
                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="outConnector"
                      label="Çıkış Konnektörü [*]"
                      value={this.state.outConnector}
                      placeHolder="Lütfen çıkış konnektörü girin..."
                      maxLength="255"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.outConnectorError}
                    />
                  </Col>
                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="pinNo"
                      label="Pin [*]"
                      value={this.state.pinNo}
                      placeHolder="Lütfen pin girin..."
                      maxLength="255"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.pinNoError}
                    />
                  </Col>
                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="arrivalConnector"
                      label="Varış Konnektörü [*]"
                      value={this.state.arrivalConnector}
                      placeHolder="Lütfen varış konnektörü girin..."
                      maxLength="255"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.arrivalConnectorError}
                    />
                  </Col>
                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="pinNo2"
                      label="Pin [*]"
                      value={this.state.pinNo2}
                      placeHolder="Lütfen pin girin..."
                      maxLength="255"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.pinNo2Error}
                    />
                  </Col>
                </Row>

                {this.state.alertErrorMessage && (
                  <CgnAlert
                    color="danger"
                    title={CgnMessage.alertErrorTitle}
                    text={this.state.alertErrorMessage}
                  />
                )}
                <CgnButtonGroup items={this.state.buttons} />
              </Card>
            </Form>

            {(this.state.urlSplit[1] === "manuel-kontrol-sablon-ekle" ||
              this.state.urlSplit[1] === "manuel-kontrol-sablon-guncelle") && (
              <CgnButtonLink
                color="secondary"
                to={"/" + this.state.pageListLink}
                text={CgnMessage.backButton}
                className="btn-back"
              />
            )}
          </Col>
        </Row>
      </>
    );
  }
}

export default withRouter(ManuelControlTemplateAddUpdate);
